/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import { InfoJobMessage } from './InformationJobMessage.jsx';
import { ButtonExportState } from './ButtonsMolstarState.jsx';
import { Controls } from './Controls.jsx';
import { Descriptions } from './Descriptions.jsx';
import { RunIndeepDesc } from './RunIndeepDesc.jsx';
import { ButtonAnalysis } from './ButtonsMolstarManage.jsx';
import "molstar/build/viewer/molstar.css";
import { LinkButtonExport } from './ExportButtons.jsx';
import { HoloResultsTable } from './HoloTable.jsx';
import { UrlMessage } from './UrlMessage.jsx';
import { TextBoxSelection } from './TextBoxSelection.jsx';
import { setBackgroundwithTheme, createPlugin } from './molstar_utils.js';
import { GetTour } from './Tours.jsx';

//axios.defaults.xsrfHeaderName = "X-CSRFToken";
//axios.defaults.xsrfCookieName = "csrftoken";
//export default axios

class IndeepWeb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plugin: null,
    };
  }

  componentDidMount() {createPlugin(document.getElementById('app')).then(plugin => {
    this.setState({ plugin });
    setBackgroundwithTheme(plugin);
    }); 
    }

  render() {
    const { plugin } = this.state;
    
    const parsedUrl = new URL(window.location.href);
    const job_id = parsedUrl.searchParams.get('job');
    
    function ButtonExport() {
      return (
        <LinkButtonExport />
        )
    }
    const handleClick = () => {
      const divmolstar = document.getElementById('app');
      //previous state of button
      if (button.classList.contains('msp-btn-link-toggle-off')) {
        //now button is on
        if (divmolstar.classList.contains('no-margin')) {
          divmolstar.classList.remove('no-margin', 'my-5');
        };
      } else if (button.classList.contains('msp-btn-link-toggle-on')) {
        //now button is off
        if (!divmolstar.classList.contains('no-margin')) {
          divmolstar.classList.add('no-margin', 'my-5');
        };
      };

    };
    const button = document.querySelector('button[title="Toggle Controls Panel"]');
    if (button) {
      button.addEventListener('click', handleClick);
    };


    return (
      <div id="main"
        className="flex flex-col space-y-6 bg-transparent my-4 mx-12 md:mx-24">
          <Descriptions />
          <RunIndeepDesc plugin={plugin}/>
          
          {plugin && <Controls plugin={ plugin } job_id={ job_id }/>}
          <div id="analysis" className="flex flex-col border-2 border-amber-500 bg-stone-100 dark:bg-stone-700 px-4 rounded-lg shadow-lg shadow-stone-800 dark:shadow-stone-400 p-5">
            <div className="flex flex-col ">
              <div className="flex-row">
                <h3 className="text-md font-semibold dark:text-gray-50">VISUALISE AND INTERACT WITH YOUR PROJECT</h3>
                <small className="text-gray-600 dark:text-gray-50">Change representation, select residues and predict pockets</small>
                <div id="tourmessageinfo">
                  <InfoJobMessage />
                  <UrlMessage />
                </div>
                {plugin && <ButtonAnalysis label="Detect Pockets" holo="Use InDeepHolo" plugin={ plugin } />}
              </div>

            </div>
            <div id="divbar-1" hidden className="w-full bg-white rounded h-10 my-4">
              <div id="progressbar-1" className="bg-blue-800 h-10 text font-medium text-gray-100 align-middle text-center py-3 px-0.5 leading-none rounded-l" style={{ width: "0%" }}> 0%</div>
            </div>
            <div id="analysis" className="w-full h-max z-50 border-stone-400 border-4">
              <div id="app" className="relative w-auto h-molstar">
              </div>
            </div> 
            {plugin &&  <TextBoxSelection plugin={ plugin }/> }
            {plugin &&  <HoloResultsTable plugin={ plugin }/> }
          </div>

          <div id='controlsexport'
            className="p-4 flex flex-col align-middle bg-stone-200 dark:bg-stone-800 rounded-lg shadow-lg border-2 border-blue-500 shadow-stone-800 dark:shadow-stone-400">
           <h3 className=" text-md font-semibold whitespace-nowrap dark:text-gray-50">EXPORT PROJECT</h3>
           <small className="text-gray-600 dark:text-gray-50">Export an InDeep<sup>Net</sup> file to conserve your project representation. Export an archive to save all your result data</small>
        
           <div className="flex flex-row font-roboto items-stretch justify-center p-2 space-x-6"> 
            <div className="flex flex-col w-full">
            <ButtonExport />
            </div>
            <div className="flex flex-col w-full">
            {plugin && <ButtonExportState plugin={ plugin }/>}
            </div>
          </div>
  
          </div>
          

      </div>
    );
  }
}

export default IndeepWeb;